import React from 'react';
import DocTemplateRow from './doc_template_row';
import DocTemplateColumnHeader from './doc_template_column_header';
import type { ColumnConfig, DocTemplate, SortDirection, SortState, TemplateActions } from './types';

type DocTemplateTableProps = TemplateActions & {
  sortState: SortState,
  teamsEnabled?: boolean,
  templates: DocTemplate[],
  onSort: (sortKey: string, direction: SortDirection) => void,
};

const columns = (teamsEnabled?: boolean): ColumnConfig[] => [
  { key: 'name', label: 'Name', sortKey: 'name' },
  { key: 'tags', label: 'Tags', sortKey: 'tags' },
  { key: 'templateType', label: 'Document Type', sortKey: 'templateType' },
  { key: 'propertyTypes', label: 'Property Type', sortKey: undefined },
  { key: 'usersAndTeams', label: teamsEnabled ? 'Users & Teams' : 'Users', sortKey: undefined },
  { key: 'createdByName', label: 'Created By', sortKey: 'createdByName' },
  { key: 'updatedAt', label: 'Last Edited', sortKey: 'updatedAt' },
  { key: 'editedByName', label: 'Edited By', sortKey: 'editedByName' },
  { key: 'proposalDefault', label: 'Default', sortKey: undefined },
  { key: 'actions', label: '', sortKey: undefined }
];

export default function DocTemplateTable({
  teamsEnabled,
  templates,
  sortState,
  onSort,
  onDuplicate,
  onAccessTemplateReport,
  onDelete,
  onSetDefault
}: DocTemplateTableProps) {
  return (
    <div className="table-container overflow-y-hidden">
      <table className="table bo-search-results bordered table-hover">
        <thead>
          <tr>
            {columns(teamsEnabled).map(col => (
              <DocTemplateColumnHeader
                columnConfig={col}
                key={col.key}
                sortState={sortState}
                onSort={onSort}
              />
            ))}
          </tr>
        </thead>
        <tbody>
          {templates.map(template => (
            <DocTemplateRow
              key={template.id}
              template={template}
              onAccessTemplateReport={onAccessTemplateReport}
              onDelete={onDelete}
              onDuplicate={onDuplicate}
              onSetDefault={onSetDefault}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
